<template>
  <div class="tree-node" :style="{ '--level': level }">
    <div class="node-content">
      <div class="node-main" @click="clicked">
        <i v-if="node.type === 'riks'" class="fas fa-sitemap"></i>
        <i v-if="node.type === 'default'" class="fas fa-building"></i>
        <i v-if="node.type === 'student' || node.type === 'workgroup'" class="fas fa-book"></i>
        <i v-if="node.type === 'member'" class="fas fa-user"></i>
        <i v-if="node.type === 'assignment'" class="fas fa-file-alt"></i>

        <div class="name-count-wrap ml-2">
          <div class="name-col">{{ node.name }}</div>
          <div class="count-col" v-if="node.type !== 'member'">({{ node.member_count || 0 }})</div>
        </div>
      </div>
      <div class="node-actions" v-if="node.type !== 'member'">
        <memlist-table-button v-if="node.member_count || 0 > 0" class="mr-2" @click="show_members(node)" icon="fa fa-user" :tooltip="$t('COMPANY.TOOLTIP_SHOW_MEMBERS')" />
        <memlist-table-button class="mr-2" @click="delete_company(node)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
        <memlist-table-button class="mr-2" @click="add_node(node)" svg="/assets/svg/plus-square.svg" :tooltip="$t('COMPANY.TOOLTIP_CREATE_SUBCOMPANY')" />
      </div>
    </div>

    <div class="children" v-if="hasChildren">
      <CompanyTreeNode
        v-for="(child, index) in node.children"
        :key="index"
        :node="child"
        :level="level + 1"
        @show_members="show_members"
        @on_click="clicked"
        @selected="selected"
        @add="emitAdd"
        @remove="emitRemove"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyTreeNode',
  emits: ['add', 'selected', 'remove', 'on_click', 'show_members'],
  props: {
    node: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    add_node(node) {
      this.$emit('add', node);
    },
    show_members(node) {
      this.$emit('show_members', node);
    },
    delete_company(node) {
      this.$emit('remove', node);
    },
    clicked() {
      this.$emit('selected', this.node);
    },
    selected(node) {
      this.$emit('selected', node);
    },
    addNode() {
      this.$emit('add', this.node);
    },
    removeNode() {
      this.$emit('remove', this.node);
    },
    emitAdd(node) {
      this.$emit('add', node);
    },
    emitRemove(node) {
      this.$emit('remove', node);
    }
  },
  computed: {
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
  },
};
</script>

<style scoped>
.name-count-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px; /* or your desired spacing */
}

.name-col {
  font-weight: 400;
}

.count-col {
  color: #666;
  font-size: 0.9em;
}
.tree-node {
  position: relative;
  padding-left: 20px;
  --connector-color: #ccc;
}

.node-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
}

.node-main {
  flex: 1;
  cursor: pointer;
}

.node-main:hover {
  background-color: #aaddff;
}

.node-actions {
  margin-left: 8px;
  display: flex;
  gap: 4px;
}

.action-btn {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 4px 6px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.action-btn svg {
  color: #444;
  font-size: 14px;
}

.action-btn:hover {
  background-color: #e0f0ff;
  border-color: #007bff;
}

.action-btn:hover i {
  color: #007bff;
}


.tree-node::before {
  content: '';
  position: absolute;
  top: 15px;
  left: 0;
  width: 10px;
  height: 1px;
  background-color: var(--connector-color);
}

.children {
  position: relative;
  margin-left: 10px;
  padding-left: 10px;
}

.children::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 100%;
  background-color: var(--connector-color);
}
</style>
